import dayjs from 'dayjs';

const DATE_FORMAT = 'DD/MM/YYYY';
const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
const TIME_FORMAT = 'HH:mm';

/**
 * Formats an ISO date string (or any dayjs-parseable value) into the
 * project-wide user-facing date format `DD/MM/YYYY`.
 *
 * Returns an empty string for nullish or invalid input so it can be used
 * directly in table cells without conditional rendering.
 */
export function formatDate(
  value: string | number | Date | null | undefined,
  format: string = DATE_FORMAT
): string {
  if (value === null || value === undefined || value === '') return '';

  const parsed = dayjs(value);
  if (!parsed.isValid()) return '';

  return parsed.format(format);
}

/**
 * Same as {@link formatDate} but also includes the time component as
 * `DD/MM/YYYY HH:mm`.
 */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  return formatDate(value, DATE_TIME_FORMAT);
}

export function formatTime(value: string | number | Date | null | undefined): string {
  return formatDate(value, TIME_FORMAT);
}
